<template>
  <v-card>
    <v-card-title><h3>Commissions Reports</h3></v-card-title>
    <v-card-text>

      <v-layout row wrap>
        <v-flex xs12 md4 class="text-xs-center" px-1 mt-2>
          <v-flex>
            <v-select
              v-model="selectedUser"
              :items="users"
              label="Select Case Manager"
            />
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  label="Start Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="menu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  label="End Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-flex xs12 md12>
            <v-data-table
              :items="completedCases"
              :headers="analyticHeaders"
              :loading="loading"
              :expand="expand"
              item-key="id"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded" class="grey lighten-2">
                  <td>{{ props.item.manager_name }}</td>
                  <td>{{ props.item.cases.length }}</td>
                  <td>{{ Math.round(Number(props.item.commission)) }}</td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-data-table
                  :items="props.item.cases"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <td>Case ID: {{ props.item.id }}</td>
                    <td>Case Wake Date: {{ props.item.wake_end }}</td>
                    <td><span v-if="props.item.services.length">Services: </span>{{ _.map(props.item.services, 'service.name').join(',') }}</td>
                    <td>Location of wake: {{ getWakeLocation(props.item.answers) }}</td>
                    <td>Commissions: {{ Math.round(Number(props.item.commissions)) }}</td>
                  </template>
                </v-data-table>
                <div class="align-right">
                  <v-btn @click="exportToCSV(props.item.cases)">Export to CSV</v-btn>
                </div>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    computed: {
      ...mapGetters({
        users: 'caseManagers',
        allCompletedCases: 'getAllCompletedGroupedCases'
      }),
      managerName () {
        return this.selectedUser && this.users.find(i => i.id === this.selectedUser) ? this.users.find(i => i.id === this.selectedUser).name : null
      }
    },
    data () {
      return {
        menu: false,
        menu1: false,
        fromDate: null,
        toDate: null,
        expand: false,
        selectedUser: null,
        completedCases: [],
        analyticHeaders: [
          { text: 'User', value: 'user.name' },
          { text: 'Completed Cases', value: 'cases.length' },
          { text: 'Commission', value: 'commission' }
        ],
        loading: true
      }
    },
    watch: {
      selectedUser (user) {
        this.filterCases()
      },
      fromDate () {
        this.filterCases()
      },
      toDate () {
        this.filterCases()
      }
    },
    methods: {
      mapCases (cases) {
        return _.map(cases, (u) => {
          return {
            id: u[0].user.id,
            manager_name: u[0].manager_name,
            user: u[0].user,
            cases: u,
            commission: _.sumBy(u, 'commissions')
          }
        })
      },
      filterCases () {
        this.completedCases = this.mapCases(this.allCompletedCases(this.fromDate, this.toDate, this.managerName))
      },
      getWakeLocation (answers) {
        const parsed = JSON.parse(answers[0].answer)
        return parsed.form_answers.main_form.deceased_location_of_wake
      },
      exportToCSV (cases) {
        const rows = []
        rows.push(['Case ID', 'Case Wake Date', 'Services', 'Location of Wake', 'Commission'])
        cases.forEach(item => {
          rows.push([item.id, item.wake_end, this.getServices(item.services), this.getWakeLocation(item.answers), item.commissions])
        })

        const userName = cases[0].user.name.toLowerCase().replace(/ /g, '_')
        const periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null
        const periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null
        let period = ''
        if (periodStart) period += `_from_${periodStart}`
        if (periodEnd) period += `_to_${periodEnd}`

        let csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n')
        let encodedUri = encodeURI(csvContent)
        // window.open(encodedUri)

        let link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `${userName}_commissions${period}.csv`)
        document.body.appendChild(link)

        link.click()
      },
      getServices (services) {
        return _.map(services, 'service.name').join('+')
      }
    },
    created () {
      this.$store.dispatch('loadAllCases').then(() => {
        this.loading = false
        this.completedCases = this.mapCases(this.allCompletedCases(null, null, null))
      })
      if (this.users.length === 0) this.$store.dispatch('getCaseManagers')
      if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans')
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories')
      if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts')
      if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts')
    }
  }
</script>

<style scoped>
  .align-right {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// Analytics.vue?fd418dfa